<template lang="pug">
  .fields-filter
    el-select(
      v-model='selectedTransmitterId'
      filterable
      :placeholder="$t('placeholder.select_transmitter')"
      @change="emitChangeEvent"
    )
      el-option(
        v-for='transmitter in transmitters'
        :key='transmitter.id'
        :label='transmitter.name'
        :value="transmitter.value !== '' ? transmitter.id : transmitter.value"
      )
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "FilterSensorTransmitterDropdown",

  props: {
    value: {
      type: [String, Number],
      default: "",
    },
  },

  computed: {
    selectedTransmitterId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    ...mapState("auth", ["user"]),
    ...mapState("site", ["clientSite"]),

  },

  data() {
    return {
      transmitters: [],
    };
  },
  
  async mounted() {
    await this.handleGetTransmitters();
  },

  methods: {
    ...mapActions("transmitter", ["getTransmitters"]),

    async handleGetTransmitters() {
      const response = await this.getTransmitters(`?page_size=1000`);
      
      if(response.data){
        this.transmitters = response.data;
        this.transmitters.unshift({
          id: 0,
          name: "All",
          value: "",
        });
      }
    },

    emitChangeEvent(values) {
      this.$emit('onChange', values)
    }
  },
};
</script>
